// Fichier GÉNÉRÉ par scripts/photos-disponibles.mjs — ne pas modifier à la main.
// Photos effectivement présentes dans public/photos/ au moment du build.
export const PHOTOS_DISPONIBLES = []
